// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'promise-polyfill/dist/polyfill';
// import preval from 'preval.macro';
import Vue from 'vue';
import App from './App';
import router from './router';
import '@/directives/index.js';
import 'element-ui/lib/theme-chalk/index.css';
import DatePicker from 'element-ui/lib/date-picker';
import Tree from 'element-ui/lib/tree';
import Input from 'element-ui/lib/input';
import Transfer from 'element-ui/lib/transfer';
import Button from 'element-ui/lib/button';
import Checkbox from 'element-ui/lib/checkbox';
import MessageBox from 'element-ui/lib/message-box';
import Message from 'element-ui/lib/message';
import Loading from 'element-ui/lib/loading';

// import dayjs from 'dayjs';

// console.log(`${process.env.NODE_ENV}--${dayjs(preval`module.exports = Date.now()`, 'YYYY-MM-DD HH:mm:ss')}`);
Vue.config.productionTip = false;

if (!Array.prototype.includes) {
  Array.prototype.includes = function includes(searchElement, fromIndex = 0) {
    const arr = this;
    return arr.slice(fromIndex).indexOf(searchElement) !== -1;
  }
}

Vue.use(DatePicker)
Vue.use(Tree)
Vue.use(Input)
Vue.use(Transfer)
Vue.use(Button)
Vue.use(Checkbox);
Vue.use(Loading);

Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$message = Message;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
});
